export default {
    ONE_HUNDRED_FIFTY:  '150',
    THREE_HUNDRED: '300',
    THREE_HUNDRED_PLUS: '300-plus',
};
